export interface Region {
  id: string;
  title: string;
  path: string;
  centroid: { x: number; y: number };
}

export const gangwonRegions: Region[] = [
  {
    id: "chuncheon",
    title: "춘천시",
    path: "M150,180 L180,175 L185,200 L165,210 L145,205 Z",
    centroid: { x: 162, y: 192 }
  },
  {
    id: "wonju",
    title: "원주시", 
    path: "M120,220 L155,215 L160,240 L135,250 L115,245 Z",
    centroid: { x: 137, y: 232 }
  },
  {
    id: "gangneung",
    title: "강릉시",
    path: "M220,200 L255,195 L265,225 L240,235 L215,230 Z",
    centroid: { x: 240, y: 217 }
  },
  {
    id: "donghae",
    title: "동해시",
    path: "M250,240 L275,235 L280,260 L265,270 L245,265 Z",
    centroid: { x: 262, y: 252 }
  },
  {
    id: "taebaek",
    title: "태백시",
    path: "M200,280 L225,275 L235,300 L210,310 L195,305 Z",
    centroid: { x: 215, y: 292 }
  },
  {
    id: "sokcho",
    title: "속초시",
    path: "M240,120 L265,115 L275,140 L250,150 L235,145 Z",
    centroid: { x: 255, y: 132 }
  },
  {
    id: "samcheok",
    title: "삼척시",
    path: "M220,320 L260,315 L270,350 L235,360 L210,355 Z",
    centroid: { x: 240, y: 337 }
  },
  {
    id: "hongcheon",
    title: "홍천군",
    path: "M120,160 L160,155 L170,185 L140,195 L110,190 Z",
    centroid: { x: 140, y: 175 }
  },
  {
    id: "hoengseong",
    title: "횡성군",
    path: "M90,200 L125,195 L135,225 L105,235 L85,230 Z",
    centroid: { x: 110, y: 215 }
  },
  {
    id: "yeongwol",
    title: "영월군",
    path: "M140,260 L175,255 L185,285 L155,295 L135,290 Z",
    centroid: { x: 160, y: 277 }
  },
  {
    id: "pyeongchang",
    title: "평창군",
    path: "M160,240 L195,235 L205,265 L175,275 L155,270 Z",
    centroid: { x: 180, y: 255 }
  },
  {
    id: "jeongseon",
    title: "정선군",
    path: "M180,280 L215,275 L225,305 L195,315 L175,310 Z",
    centroid: { x: 200, y: 297 }
  },
  {
    id: "cheorwon",
    title: "철원군",
    path: "M100,100 L140,95 L150,125 L120,135 L95,130 Z",
    centroid: { x: 122, y: 115 }
  },
  {
    id: "hwacheon",
    title: "화천군",
    path: "M140,120 L175,115 L185,145 L155,155 L135,150 Z",
    centroid: { x: 160, y: 137 }
  },
  {
    id: "yanggu",
    title: "양구군",
    path: "M180,100 L210,95 L220,125 L190,135 L175,130 Z",
    centroid: { x: 197, y: 115 }
  },
  {
    id: "inje",
    title: "인제군",
    path: "M200,140 L235,135 L245,165 L215,175 L195,170 Z",
    centroid: { x: 220, y: 155 }
  },
  {
    id: "goseong",
    title: "고성군",
    path: "M220,80 L250,75 L260,105 L235,115 L215,110 Z",
    centroid: { x: 237, y: 95 }
  },
  {
    id: "yangyang",
    title: "양양군",
    path: "M240,160 L270,155 L280,185 L255,195 L235,190 Z",
    centroid: { x: 257, y: 177 }
  }
];